import { render, staticRenderFns } from "./ShengJiaolianManage.vue?vue&type=template&id=266f3d00&"
import script from "./ShengJiaolianManage.vue?vue&type=script&lang=js&"
export * from "./ShengJiaolianManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports